import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  width: '760px',
  maxWidth: '72vw',
  [mobile]: {
    width: '100%',
    maxWidth: 'none',
  },
};

const head: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  marginBottom: 12,
  h4: { fontSize: 15, fontWeight: 700, color: theme.color.text },
};

const searchRow: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: '0 6px',
  [mobile]: {
    width: '100%',
    '> input': { flex: 1, minWidth: 0 },
  },
};

const listWrap: CSSObject = {
  minHeight: 320,
  maxHeight: 420,
  overflow: 'auto',
  [mobile]: {
    minHeight: 200,
    maxHeight: '50vh',
  },
};

export { wrap, head, searchRow, listWrap };
